import { defineStore } from 'pinia';
import { LxViewStore } from '@dativa-lv/lx-ui';

export default defineStore('viewStore', {
  ...LxViewStore,
  actions: {
    ...LxViewStore.actions, // Keep existing actions
    addBreadcrumbOverride(code, value) {
      let index = -1;
      if (this.breadcrumbOverrides) {
        index = this.breadcrumbOverrides.findIndex((obj) => obj.code === code);
      }

      if (index !== -1) {
        this.breadcrumbOverrides[index].value = value;
      } else {
        this.overrideBreadcrumbs(code, value);
      }
    },
    setLocale(locale) {
      this.locale = locale;
      localStorage.setItem('locale', locale); // store locale in localStorage
    },
  },
});
